<template>
  <div
    data-qa="lpu_related_clinics_item"
    class="related-clinic-item rounded-20 pa-4"
    :class="{
      'bg-gray-40': isStriped,
      'related-clinic-item--mobile flex-column ga-4': isMobile,
      'd-flex align-center ga-5': !isMobile,
    }"
  >
    <div class="flex-grow-1 min-w-0 d-flex flex-column">
      <a
        data-qa="lpu_related_clinics_name"
        class="related-clinic-item__name text-subtitle-1 font-weight-medium primary--text text-decoration-none"
        :href="clinic.url"
      >
        {{ clinic.name }}
      </a>

      <div
        v-if="clinic.address"
        class="d-flex align-center ga-2 mt-2"
      >
        <span
          class="ui-icon-ui-location ui-icon-fz-smaller bg-gray-80--text flex-shrink-0"
          aria-hidden="true"
        />
        <span class="text-body-2 text-secondary--text">
          {{ clinic.address }}
        </span>
      </div>
    </div>

    <div
      v-if="phoneFormatted"
      class="related-clinic-item__phone d-flex align-center ga-2 flex-shrink-0"
    >
      <a
        data-qa="lpu_related_clinics_phone"
        class="d-flex align-center ga-2 text-subtitle-1 font-weight-medium text--text text-decoration-none"
        :class="isMobile ? 'mt-2' : ''"
        :href="`tel:${phoneHref}`"
      >
        <span
          v-if="!isMobile"
          class="ui-icon-phone-call ui-icon-fz-big bg-gray-80--text flex-shrink-0"
          aria-hidden="true"
        />
        {{ phoneFormatted }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import filterFirstPhone from 'common/filters/filterFirstPhone'
import formatPhone from 'src/functions/formatPhone'
import useContextStore from 'src/store/useContextStore'
import type { RelatedLpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRelatedClinics/types'

const props = withDefaults(defineProps<{
  clinic: RelatedLpu
  isStriped?: boolean
}>(), {
  isStriped: false,
})

const isMobile = useIsMobile()
const { context } = useContextStore()

const rawPhone = computed(() => {
  if (!props.clinic.phone) {
    return ''
  }

  return filterFirstPhone(String(props.clinic.phone))
})

const phoneFormatted = computed(() => {
  if (!rawPhone.value) {
    return ''
  }

  return formatPhone({
    phone: rawPhone.value,
    country: context.request.country,
  })
})

const phoneHref = computed(() => {
  if (!rawPhone.value) {
    return ''
  }

  return formatPhone({
    phone: rawPhone.value,
    country: context.request.country,
    isRaw: true,
  })
})
</script>

<style lang="scss" scoped>
.related-clinic-item {
  &--mobile &__phone {
    width: 100%;
  }

  &__name {
    word-break: break-word;
  }
}
</style>
